/* =====================================================================
   SAGE LIFESTYLE — ALL SITE TEXT
   Everything the site says that is NOT a product lives in this file. Products (names, prices, photos, sizes,
   descriptions) are edited in Shopify admin → Products as usual; the lookbook photos in Customize → Sage home.

   HOW TO EDIT SAFELY
   • Only change the text between the double quotes "like this".
   • Keep the quotes, the commas at the end of lines, and the { } [ ] brackets as they are.
   • Apostrophes are fine (don't, it's). Don't type a double quote " inside a text.
   • Words in curly brackets like {count} or {name} are filled in by the site. Keep them as they are.
   • Lists in [ square brackets ] can grow or shrink: copy or delete a whole item, including its trailing comma.
   • Numbers are written in quotes too, e.g. "12480".
   • Notes like this one, between the slash-star marks, are for you; the site ignores them.
   • If a line is wrong or missing, the site uses its built-in text for that line, so the page never breaks.
     To undo a change, use "Older versions" at the top of this file in the Shopify code editor.

   Also editable without this file:
   • Browser tab title and Google description of the home page: layout/theme.liquid.
   • Hero and Reel videos: Customize → Theme settings → Media (or "media" below, which wins if filled in).
   ===================================================================== */
var SAGE_SITE_CONTENT = {

  /* ===================================================================
     EVERY PAGE
     =================================================================== */

  /* Logo text: top-left of every page, the loading screen and the footer. */
  brand: {
    name: "SAGE",
    sub: "LIFESTYLE",
  },

  /* Loading screen (home page only). The steps cycle while the bar fills. */
  preloader: {
    steps: ["Preparing the drop", "Loading the collection", "Pressing the prints", "Almost ready", "Welcome"],
    hint: "Click to enter",
  },

  /* Top menu bar (desktop) and the phone menu. */
  nav: {
    drops: "Colourways",
    reel: "Reel",
    arsenal: "Shop",
    lookbook: "Lookbook",
    guild: "Guild",          /* phone menu only */
    about: "About",
    searchPlaceholder: "Search tees — goku, pokémon, black…",
    soundOn: "Sound on",     /* little message after pressing the speaker icon */
    soundOff: "Sound off",
    menuFootLink: "sagelifestyle.in",   /* bottom-left of the phone menu */
    menuFootUrl: "https://sagelifestyle.in",
    menuFootNote: "Drop 01 · Now Live", /* bottom-right of the phone menu */
  },

  /* Social links: footer "Social" column and the Contact page. */
  social: [
    { label: "Instagram", url: "https://www.instagram.com/sagelifestyle.in/" },
    { label: "Facebook", url: "https://www.facebook.com/share/19YJh3nVPa/" },
  ],

  /* Footer at the bottom of every page. */
  footer: {
    tagline: "Oversized anime & pop-culture streetwear from India. Heavyweight by default.",
    shopTitle: "Shop",
    allProducts: "All Products",
    colourways: "Colourways",
    lookbook: "Lookbook",
    newArrivals: "New Arrivals",
    supportTitle: "Support",
    about: "About Us",
    contact: "Contact",
    sizeGuide: "Size Guide",
    socialTitle: "Social",
    wordmark: "SAGE",        /* the giant outlined word */
    copyright: "© 2026 Sage Lifestyle. All rights reserved.",
    madeIn: "Made in India 🇮🇳",
  },

  /* Shopping cart panel (opens from the bag icon) and its pop-up messages. */
  cart: {
    kicker: "Shopping Bag",
    title: "Your Cart",
    empty: "Your cart is empty",
    startShopping: "Start Shopping",
    subtotal: "Subtotal",
    shipping: "Shipping",
    shippingFree: "Free",
    shippingFreeAbove: "Free above ₹{amount}",
    freeShippingFrom: "999",                   /* order value (₹) from which shipping shows as free */
    checkout: "Checkout",
    secureNote: "Secure checkout by Shopify",
    remove: "Remove",
    sizeLabel: "Size",
    added: "{name} ({size}) added to cart",    /* pop-up after adding a tee */
    outOfStock: "Size {size} is out of stock",
    pickSize: "Please select a size",
  },

  /* Size guide pop-up (footer "Size Guide", product page, support pages). */
  sizeGuide: {
    kicker: "Size Guide",
    title: "Oversized Fit Chart",
    columns: ["Size", "Chest (in)", "Length (in)", "Shoulder (in)"],
    rows: [
      ["S", "42", "27", "21"],
      ["M", "44", "28", "22"],
      ["L", "46", "29", "23"],
      ["XL", "48", "30", "24"],
    ],
    note: "Oversized by design. Size down for a regular fit, size up for full drop-shoulder.",
  },

  /* Product cards in every product grid (home shop, New Arrivals). */
  productCard: {
    hoverLabel: "View",        /* word in the round cursor bubble over a product photo */
    newBadge: "New",           /* red badge on the first three tees (sale tees show their discount instead) */
    front: "Front",
    back: "Back",
    viewProduct: "View Product",
    shop: "Shop →",
  },

  /* Product page (/products/…). The product's own name, price, photos and description come from Shopify admin.
     Top to bottom on the right of the photos: breadcrumb, name, price, sizes, buttons, the changing line, the three
     badges, then the fold-out sections (Description, Specifications, Product Care, Shipping & Returns, Additional Info). */
  productPage: {
    breadcrumbHome: "Home",
    breadcrumbShop: "Shop",
    save: "Save {percent}%",
    taxNote: "Inclusive of all taxes.",   /* small line under the price */
    selectSize: "Select Size",
    sizeGuide: "Size Guide",
    addToCart: "Add To Cart",
    buyNow: "Buy It Now",                  /* skips the cart and goes straight to checkout with this item */
    perks: ["Free shipping above ₹999", "Ships in 2–4 days", "240 GSM heavyweight cotton", "Oversized fit · drop shoulder"],   /* the line under the buttons; shows one at a time, changing every few seconds */
    /* the three badges with icons under that line. icon can be: truck, pin, returns, cotton, india */
    badges: [
      { icon: "truck", label: "Ships in 2–4 days" },
      { icon: "pin", label: "Pan-India delivery" },
      { icon: "returns", label: "2-day returns" },
    ],
    detailsTitle: "Description",           /* first fold-out: the product description from Shopify admin (open to start) */
    readMore: "Read more",                 /* under a long description, which shows its first few lines */
    readLess: "Read less",
    specsTitle: "Specifications",
    specs: [
      { label: "Fabric", value: "240 GSM cotton" },
      { label: "Fit", value: "Oversized · drop shoulder" },
      { label: "Print", value: "High-density full back" },
      { label: "Wash", value: "Bio-washed · pre-shrunk" },
      { label: "Origin", value: "Made in India" },
    ],
    careTitle: "Product Care",
    care: [
      "Machine wash cold, inside out, with similar colours.",
      "Do not bleach. Do not tumble dry.",
      "Iron inside out on low heat; never iron directly on the print.",
    ],
    shippingTitle: "Shipping & Returns",
    shipping: [
      "Ships across India in 2–4 days.",
      "Free shipping on orders above ₹999.",
      "Raise a return within 2 days of delivery; the tee must be unused with its tags on.",
    ],
    policyLink: "{label} policy",          /* links under Shipping & Returns to the policy pages, e.g. "Shipping policy" */
    infoTitle: "Additional Info",
    info: [
      "Colours can look slightly different on screen than in person, depending on lighting and display settings.",
    ],
    relatedTitle: "You May Also Like",     /* heading of the product carousel at the bottom of the page */
  },

  /* Colour names shown as "classes" (home colourway tiles) and the swatch colour of each. */
  colours: {
    Black: { className: "SHADOW", swatch: "#111111" },
    Coffee: { className: "RANGER", swatch: "#5a3a2a" },
    White: { className: "PALADIN", swatch: "#eeeeee" },
    Lavender: { className: "MYSTIC", swatch: "#b9a6e0" },
  },

  /* ===================================================================
     HOME PAGE (top to bottom)
     =================================================================== */

  /* Home page videos: the hero (first screen) and the Reel (section 4). Each one can be different.
     Leave a link "" to use Customize → Theme settings → Media instead. */
  media: {
    video: "",       /* HERO: the film behind the first screen (MP4 link) */
    poster: "",      /* HERO: image shown while that video loads */
    reelVideo: "",   /* REEL: the film that plays as visitors scroll the Reel section. Leave "" to reuse the hero video. */
    reelPoster: "",  /* REEL: image shown while the Reel video loads */
  },

  /* 1 · Hero: the first screen. The product card on the right is the product tagged "featured" in Shopify admin. */
  hero: {
    tag: "Drop 01 · Anime Oversized · Now Live",
    title: "Wear Your",            /* first line, black */
    titleAccent: "Power Level",    /* second line, red */
    description: "Heavyweight 240 GSM oversized tees for players who don't do subtle. Anime, comics and legends, printed bold and cut boxy.",
    primaryButton: "Shop The Drop",
    secondaryButton: "Watch Reel",
    featuredLabel: "Featured",     /* label on the product card */
    /* The numbers along the bottom. "products" shows how many products are live in the store. */
    stats: [
      { label: "Happy Customers", value: "12480", after: "+" },
      { label: "Designs Live", value: "products", after: "" },
      { label: "Fabric Weight", value: "240", after: " GSM" },
    ],
    scrollHint: "Scroll to explore",
  },

  /* 2 · Red scrolling strip under the hero. */
  ticker: [
    "Free shipping on orders ₹999+",
    "Drop 01 — Anime Oversized is live",
    "240 GSM heavyweight cotton",
    "New players get 10% off",
    "Ships across India",
    "Limited stock — respawn not guaranteed",
  ],

  /* 3 · Colourway tiles ("Select Your Class"). {count} = number of colours in stock, {countWord} = the same in words. */
  colourways: {
    kicker: "Shop by Colour",
    title: "Select Your",
    titleAccent: "Class",
    sub: "{countWord} colourways, one heavyweight oversized fit. Pick the one that suits your style.",
    classLabel: "Class",               /* "Class 01" on each tile */
    designs: "{count} Designs",        /* count of tees in that colour */
    designsOne: "{count} Design",
    tileHover: "Shop",                 /* word in the cursor bubble on hover */
  },

  /* 4 · The Reel: the film that plays as you scroll. Each step is one screen of text over the film. */
  reel: {
    kicker: "The Reel",                /* first step's label, after the section number */
    steps: [
      { kicker: "", title: "Built For", titleAccent: "The Grind", text: "" },
      { kicker: "Fabric", title: "240 GSM", titleAccent: "Heavyweight", text: "Dense, structured cotton that holds its shape wash after wash." },
      { kicker: "Silhouette", title: "Drop Shoulder", titleAccent: "Boxy. Bold.", text: "Cut oversized on purpose. Streetwear proportions, anime energy." },
      { kicker: "Print", title: "Full-Back", titleAccent: "Artwork", text: "High-density prints that don't crack, peel or fade." },
    ],
    hint: "Scroll to scrub",
  },

  /* 5 · Shop: all products with colour and universe filters. */
  shop: {
    kicker: "Shop All",
    title: "The",
    titleAccent: "Collection",
    sub: "Hover a tee to see the back print. Pick a size to add it straight to your cart.",
    colourFilter: "Colour",
    universeFilter: "Universe",
    all: "All",
    items: "{count} Items",
    itemsOne: "{count} Item",
    emptyTitle: "Coming soon",                       /* store has no products */
    emptyText: "New pieces are on the way. Check back shortly.",
    noMatchTitle: "No matches",                      /* filters or search found nothing */
    noMatchText: "Try another filter or search term.",
  },

  /* 6 · Numbers strip under the shop. */
  specs: [
    { value: "240", after: "", unit: "GSM", text: "Heavyweight combed cotton" },
    { value: "100", after: "%", unit: "Cotton", text: "Bio-washed, pre-shrunk" },
    { value: "4", after: "", unit: "Sizes", text: "S · M · L · XL oversized fit" },
    { value: "30", after: "%", unit: "Off", text: "Launch pricing on every drop" },
  ],

  /* 7 · Lookbook. The photos, the small label and the text under the heading are set in Customize → Sage home.
     The heading is title + titleAccent joined with no space (Look + book). */
  lookbook: {
    title: "Look",
    titleAccent: "book",
    kicker: "In The Wild",     /* only used outside Shopify, where Customize isn't available */
    sub: "Real fits from the community. Tag @sagelifestyle to get featured.",
    photoHover: "View",
    emptyEditorHint: "No lookbook photos yet. Add them under Sage home → Lookbook photo in the sidebar.",
  },

  /* 8 · Giant sliding words (home and About pages). */
  statement: {
    line1: "Level Up",
    line2: "Your Wardrobe",
  },

  /* 9 · Newsletter box ("Join The Guild"). */
  guild: {
    title: "Join The",
    titleAccent: "Guild",
    text: "Early access to new drops, restock alerts and member-only offers. No spam, ever.",
    placeholder: "Your email address",
    button: "Join",
    success: "✓ You're in. Welcome to the Guild.",
    toast: "Welcome to the Guild",
  },

  /* ===================================================================
     ABOUT PAGE (/pages/about)
     =================================================================== */
  about: {
    tag: "About Sage Lifestyle",
    title: "Dressing the",
    titleAccent: "main characters",
    description: "Born from a 5 AM dream: 90s nostalgia and gaming culture, made into heavyweight oversized streetwear. Made in India.",
    storyButton: "Our story",
    shopButton: "Shop the drop",
    scrollHint: "Scroll",
    /* Big paragraph whose words light up as you scroll. */
    manifesto: "Fashion should be more than just trendy. It should be personal. We bring back the stories we grew up with, stitched into every piece.",
    /* The sideways-scrolling story. Add or remove chapters freely. */
    storyKicker: "Our story",
    storyTitle: "How it",
    storyTitleAccent: "started",
    levelLabel: "Level",
    chapters: [
      { title: "The 5 AM Dream", text: "Sage Lifestyle was born from a 5 AM dream, the kind that lingers and refuses to fade. Our founder, Gunjan Jagdish Panchal, turned that early spark into a bold vision: nostalgic memories made into wearable fashion." },
      { title: "90s Nostalgia", text: "Where mass production drowns out individuality, we chose to slow down. Inspired by the charm of the 90s, we make premium, carefully curated pieces that blend timeless emotion with modern style." },
      { title: "Enter Gaming", text: "As our community grew, a new nostalgia emerged. India’s gaming scene is booming with players, creators and esports fans, yet it has no fashion identity of its own. That’s where Sage Lifestyle steps in." },
      { title: "The Mission", text: "Cut through the clutter of mass fashion with a refined, selective collection of high-quality, nostalgia-driven apparel. Not just style, but stories: the 90s memory you grew up on, or the battleground you dominate today." },
      { title: "The Vision", text: "To be the go-to brand where fashion meets memory: wardrobes filled with moments that matter, from after-school classics to midnight gaming sessions with your squad." },
    ],
    /* Numbers strip. value "products" = live product count, "universes" = number of anime/comic universes in stock.
       In text, {universes} lists those universes. A stat whose number is 0 is hidden. */
    stats: [
      { value: "240", after: "", unit: "GSM", text: "Heavyweight combed cotton" },
      { value: "100", after: "%", unit: "Cotton", text: "Bio-washed, pre-shrunk" },
      { value: "products", after: "", unit: "Designs", text: "Live in the store right now" },
      { value: "universes", after: "", unit: "Universes", text: "{universes}" },
    ],
    ctaKicker: "Your move",
    ctaTitle: "Ready to",
    ctaTitleAccent: "level up?",
    ctaText: "New drops land with the Guild first. The rest is in the shop.",
    ctaShop: "Shop the drop",
    ctaGuild: "Join the Guild",
  },

  /* ===================================================================
     NEW ARRIVALS PAGE (/collections/new-arrivals). The tees themselves are the store's products, newest first.
     =================================================================== */
  newArrivals: {
    section: "Shop",
    kicker: "New arrivals",
    title: "Fresh",
    titleAccent: "drops",
    intro: "{count} tees, newest first.",
    introOne: "{count} tee, newest first.",
    latest: "Latest drop: {date}.",
    empty: "New pieces are on the way. Check back shortly.",
    spotlightBadge: "Just dropped",
    quickAdd: "Quick add",
    pickSize: "Pick a size",
    sizeAdded: "Size {size} added",
    viewProduct: "View product",
    alsoInDrop: "Also in this drop",
    dropLabel: "Drop",
    earlier: "Earlier",
    tees: "{count} tees",
    teesOne: "{count} tee",
    ctaKicker: "Next drop",
    ctaTitle: "Be first in",
    ctaTitleAccent: "line",
    ctaGuild: "Join the Guild",
    ctaShop: "Shop all",
  },

  /* ===================================================================
     SUPPORT PAGES: CONTACT (/pages/contact) and the policies (/policies/…)
     =================================================================== */

  /* Shared by all support pages: the small tabs under the heading and the box at the bottom. */
  support: {
    kicker: "Support",
    tabContact: "Contact",
    tabSizeGuide: "Size guide",
    helpKicker: "Still need help?",       /* box at the bottom of the policy pages */
    helpTitle: "Talk to a",
    helpTitleAccent: "real person",
    helpContact: "Contact us",
    helpWhatsApp: "WhatsApp",
    quickKicker: "Quick answers",         /* box at the bottom of the Contact page */
    quickTitle: "Most questions are",
    quickTitleAccent: "answered here",
    quickPolicy: "{label} policy",
    policiesKicker: "Policies",
    onThisPage: "On this page",
    factsLabel: "At a glance",
  },

  /* Contact details: Contact page cards, policy texts and the help box. */
  contact: {
    email: "support@sagelifestyle.in",
    phone: "+91 97693 33682",          /* shown as written */
    phoneDial: "+919769333682",        /* used for the call link: digits only, with country code */
    whatsapp: "https://wa.me/919769333682",
    address: ["Akshay Building, Jeevan Vikas Kendra Marg", "Vile Parle East, Mumbai 400057"],
    mapLink: "https://www.google.com/maps/search/?api=1&query=Akshay%20Building%2C%20Jeevan%20Vikas%20Kendra%20Marg%2C%20Vile%20Parle%20East%2C%20Mumbai%20400057",
    opensAt: "9",                      /* opening hour, 24-hour clock, India time (drives "Open now") */
    closesAt: "23",                    /* closing hour */
    hours: "Every day, 9 am – 11 pm IST",
  },

  /* Contact page wording. */
  contactPage: {
    kicker: "Contact",
    title: "Get in",
    titleAccent: "touch",
    intro: "Have a question but not sure who to ask? Get in touch and a member of our team will reach out to you.",
    emailLabel: "Email",
    emailNote: "Best for orders, returns and photos of a damaged parcel.",
    phoneLabel: "Phone & WhatsApp",
    whatsappLink: "Chat on WhatsApp",
    addressLabel: "Address",
    mapLinkLabel: "Open in Maps",
    hoursLabel: "Hours",
    openNow: "Open now",
    closedNow: "Closed now, back at 9 am",
    socialLabel: "Stay connected",
    formKicker: "Send a message",
    formTitle: "What's it",
    formTitleAccent: "about?",
    topics: ["Order & delivery", "Returns & refunds", "Sizing", "Collabs & bulk orders", "Something else"],
    nameLabel: "Name",
    emailFieldLabel: "Email",
    phoneFieldLabel: "Phone (optional)",
    messageLabel: "Message",
    messageHintOrder: "Include your order ID so we can find it quickly.",   /* for the first two topics */
    messageHint: "Tell us what you need.",
    send: "Send message",
    sentTitle: "Message sent.",
    sentText: "Thanks for writing in. A member of our team will reach out to you soon.",
    mailTitle: "Your email app should now be open.",       /* preview site only, where Shopify can't send */
    mailText: "Your message is ready to send there. Nothing opened? Write to {email}.",
    editMessage: "Edit the message",
  },

  /* Policy pages. In the texts, **double asterisks** make words bold, {email} and {phone} show the contact details
     from "contact" above (the email becomes a link).
     Each section's "blocks" is a list of: { p: "a paragraph" }, { ul: ["bullet", "bullet"] } or { ol: ["step 1", "step 2"] }.
     The two page addresses (shipping-policy, refund-policy) are fixed; don't rename them. */
  policies: {
    "shipping-policy": {
      label: "Shipping",                  /* tab, footer link and help-box button */
      title: "Shipping",
      titleAccent: "policy",
      intro: "We aim to deliver your orders quickly, safely and efficiently. This policy covers the delivery of products bought on sagelifestyle.in.",
      facts: [
        { value: "Pan-India", label: "We ship across India" },
        { value: "1–3 days", label: "To process your order" },
        { value: "2–4 days", label: "Delivery to metro cities" },
        { value: "48 hours", label: "To report a damaged parcel" },
      ],
      sections: [
        { title: "Shipping coverage", blocks: [
          { ul: ["We currently ship across India.", "For international orders, please contact our support team at {email} before placing the order."] },
        ] },
        { title: "Order processing time", blocks: [
          { ul: ["All confirmed orders are processed within **1–3 business days** (excluding Sundays and public holidays).", "Orders placed after **5:00 PM IST** will be processed the next business day."] },
        ] },
        { title: "Shipping charges", blocks: [
          { ul: ["Standard shipping charges may apply based on the delivery location and order value.", "Free shipping may be offered within the same city of manufacturing.", "Shipping charges, if any, will be displayed at checkout before payment."] },
        ] },
        { title: "Delivery timelines", blocks: [
          { ul: ["Metro cities: **2–4 business days**", "Other cities and towns: **3–4 business days**", "Remote and rural areas: **5–6 business days**"] },
          { p: "These are estimated delivery timelines. Actual delivery may vary due to courier delays, strikes, natural calamities or unforeseen circumstances." },
        ] },
        { title: "Order tracking", blocks: [
          { ul: ["Once shipped, you will receive a tracking number and courier partner details via email, SMS or WhatsApp.", "You can track your order status directly on the courier partner’s website or app."] },
        ] },
        { title: "Delivery attempts", blocks: [
          { ul: ["Our courier partners will attempt delivery up to **2 times**.", "If undelivered due to an incorrect address, unavailability or refusal, the package will be returned to us.", "In such cases, re-shipping charges will be borne by the customer."] },
        ] },
        { title: "Packaging & dispatch", blocks: [
          { ul: ["All products are packed securely to prevent damage during transit."] },
          { p: "Each package includes the mandatory details required by the Legal Metrology (Packaged Commodities) Rules, 2011, such as:" },
          { ul: ["Seller’s name and address", "Customer’s name and address", "Product details (quantity, size, etc.)", "MRP (inclusive of all taxes)"] },
        ] },
        { title: "Delays & liability", blocks: [
          { p: "While we ensure timely dispatch, we are not liable for delays caused by:" },
          { ul: ["Courier service disruptions", "Natural calamities, lockdowns or emergencies", "Incorrect or incomplete shipping addresses provided by the customer"] },
        ] },
        { title: "Damaged or lost packages", blocks: [
          { ul: ["If your package is lost in transit, we will issue a **full refund or replacement at no extra cost**.", "If the product arrives damaged, please share an **unboxing video and photos** with our support team **within 48 hours of delivery** for verification and resolution."] },
        ] },
        { title: "Contact us", blocks: [
          { p: "For any shipping-related queries, please reach out:" },
          { ul: ["Email: {email}", "Phone / WhatsApp: **{phone}**"] },
        ] },
      ],
    },
    "refund-policy": {
      label: "Returns",
      title: "Returns &",
      titleAccent: "refunds",
      intro: "Return, refund and damage policy. We want you to have a smooth shopping experience with us, so please read it carefully.",
      facts: [
        { value: "2 days", label: "To raise a return or refund request" },
        { value: "Unused", label: "With all tags and packaging intact" },
        { value: "Photos", label: "Or a video, for a damaged or wrong item" },
        { value: "2 days", label: "To credit an approved refund" },
      ],
      sections: [
        { title: "Return & refund eligibility", blocks: [
          { ul: ["You must raise a return or refund request within **2 days of receiving the product**.", "Returns are accepted only if the product is **unused, in original condition, and with all tags and packaging intact**.", "Refunds will be processed only after inspection and approval."] },
        ] },
        { title: "Damaged or defective products", blocks: [
          { ul: ["If you receive a **damaged, defective or wrong product**, kindly email us within **2 days of delivery** with your **Order ID, reason, and clear product photos or videos**.", "Our team will review your request and respond within **2 business days**."] },
        ] },
        { title: "The process", blocks: [
          { ol: ["Email us at {email} with your order details and photos.", "Our team will verify and confirm the request.", "If approved, we will arrange a pickup or ask you to ship it back.", "Inspection will be done before final approval.", "If a refund is approved, it will be credited to your original payment method within **2 working days**.", "If a replacement is approved, a **new product will be shipped and delivered within 2 working days**."] },
        ] },
      ],
    },
  },

};
/* Don't change the line below. */
(window.SAGE_CONTENT = window.SAGE_CONTENT || []).push(SAGE_SITE_CONTENT);
